export default [
  {
    path: '/pages/sample',
    component() {
      return import('@/pages/sample1.vue')
    },
  },
  {
    path: '/pages/sample2',
    component() {
      return import('@/pages/sample2.vue')
    },
  },
  {
    path: '/check/all-images',
    component() {
      return import('@/views/AllImages.vue')
    },
  },
]
